<template>
  <div class="text-block graph-header-wrap position-relative d-flex flex-column align-items-center text-center">
    <text-fragment
      class="graph-header"
      :class="[ bg === accent ? 'over-accent' : '' ]"
      :data="{ txt: 'RESPONDENTS SAY:' }"
      :style="{ background: 'linear-gradient(135deg, ' + grad[0] + ' 0%, ' + grad[1] + ' 100%)' }"
      tag="h3"
      v-if="!hideHeadTag"
    />

    <text-fragment
      class="centered-wrap mb-0 graph-copy"
      :data="copy"
      :style="{ opacity: copyAlpha, color: copyColor, height: subH }"
      @transitionend.native="handleFade"
      :ind-override="ind"
      ref="sub"
      v-if="copy.txt"
    />
  </div>
</template>

<script>
  import { industryTypes } from '@/lib/consts'
  import { gradPtColor } from '@/lib/funcs'
  import StateMixin from '@/components/report/mixins/StateMixin'
  import TextFragment from '@/components/report/content/TextFragment'

  export default {
    name: 'GraphHeader',
    mixins: [ StateMixin ],
    props: {
      data: { type: [ Object, String ], required: true },
      indOverride: String,
      botHeld: Boolean,
      hideHeadTag: { type: Boolean, default () { return false } },
      bg: { type: String, default () { return this.mainColor } }
    },
    data () {
      return {
        copy: typeof this.data === 'string' ? { txt: this.data, class: 'adobe-italic', size: 24 } : this.data,
        copyAlpha: 1,
        indRegex: /(<[a-z]+\s[^>]*"industry-word"[^>]*>)[\w\.]*(<\/([a-z]+)>)/gi,
        swapRegex: /(<[a-z]+\s[^>]*"word-swap"[^>]*>)([\w\.]*)(<\/([a-z]+)>)/gi,
        ind: null,
        subH: 'auto'
      }
    },
    computed: {
      grad () {
        return [ gradPtColor( ...this.colorsRev, 0.15 ), gradPtColor( ...this.colorsRev, 0.85 ) ]
      },
      copyColor () {
        return this.bg.match( /^#f{3,6}$/i ) ? '#000' : '#fff'
      }
    },
    watch: {
      botHeld () {
        this.initFade()
      },
      data () {
        this.copyAlpha = 0
      },
      industry () {
        this.initFade()
      }
    },
    methods: {
      initFade () {
        if ( this.copy.txt.match( /<[^>]*"(?:industry-word|word-swap)"[^>]*>/i ) ) {
          this.copyAlpha = 0
        }
      },
      handleFade ( { target: { style: { opacity } } } ) {
        if ( opacity === '0' ) {
          this.copy = typeof this.data === 'string' ? { txt: this.data, class: 'adobe-italic', size: 24 } : this.data
          this.setIndWords()
          this.$nextTick( () => {
            this.copyAlpha = 1
          } )
        }
      },
      setIndWords () {
        this.ind = this.industry
        this.copy.txt = this.copy.txt.replace( this.indRegex, '$1' + industryTypes[ this.ind ].shortName + '$2' )

        this.copy.txt = this.copy.txt.replace( this.swapRegex, ( m, oTag, content, cTag ) => {
          let base = oTag.match( /data-base="(\w*)"/i )
          let alt = oTag.match( /data-alt="(\w*)"/i )

          switch ( true ) {
            case (base instanceof Array && !this.botHeld):
              return oTag + base[ 1 ] + cTag
            case (alt instanceof Array && this.botHeld):
              return oTag + alt[ 1 ] + cTag
            default:
              return oTag + content + cTag
          }
        } )
      }
    },
    mounted () {
      this.setIndWords()
      setTimeout( () => {
        this.subH = this.$refs.sub.$el.clientHeight + 'px'
      }, 250 )
    },
    components: {
      TextFragment
    }
  }
</script>

<style lang="scss" scoped>
  .graph-header-wrap {
    z-index : 5;
  }
</style>



// WEBPACK FOOTER //
// src/components/report/content/GraphHeader.vue